import React from 'react';

import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { PERSONAL_LOAN_VERTICAL } from 'types/mrph.vertical.constants';
import { PL_HIGH_SCORE } from 'types/morph.pagePosition.constants';
import { useLinkHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import metadataMap from './OfferCardConfig';
import OfferModuleView from 'partial/OfferManager/modules/PersonalLoanHighScoreModule/OfferModuleView';
import 'partial/OfferManager/modules/PersonalLoanHighScoreModule/OfferModule.scss';

/*
    Personal Loan High Score Offer Module
*/
export const PLHighScoreOfferModuleController = props => {
  const atr = getViewModuleTrackingAttributes({
    pagePosition: PL_HIGH_SCORE,
    modulePosition: props.modulePosition,
    vertical: PERSONAL_LOAN_VERTICAL,
  });
  const onLinkClickEvent = useLinkHandler(props.eventHandler);

  const seenPixel = useSeenModulePixel(atr);

  const marketPlaceCards = [
    {
      tileIconKey: 'travel_icon',
      ...metadataMap.TRAVEL,
    },
    {
      tileIconKey: 'new_home_icon',
      ...metadataMap.HOME_IMPROVEMENT,
    },
    {
      tileIconKey: 'celebrate_icon',
      ...metadataMap.WEDDING,
    },
    {
      tileIconKey: 'medical_icon',
      ...metadataMap.MEDICAL,
    },
    {
      tileIconKey: 'pool_icon',
      ...metadataMap.SWIMMING_POOL,
    },
    {
      tileIconKey: 'personal_loan_icon',
      ...metadataMap.OTHER,
    },
  ];

  const loading = props.globalLoadingFlag;
  if (loading) {
    return <LoadingMask />;
  } else {
    return (
      <OfferModuleView
        titleText={
          'Shop low rates on a personal loan for your next big purchase'
        }
        subTitle={'What do you want to get a loan for?'}
        seenPixel={seenPixel}
        marketPlaceCards={marketPlaceCards}
        onLinkClickEvent={onLinkClickEvent}
        {...props}
      />
    );
  }
};
